import React from "react";
import { useDispatch } from "react-redux";
import { Col, Row } from "reactstrap";
import { setOrderFilter } from "../../store/orderSlice";

const SubFilters = ({ orderState, isDisabled }) => {
  const dispatch = useDispatch();
  const { orderStatusSummary: statusSummary, filter } = orderState;
  const { customStatus, subCustomStatus: activeSubStatus } = filter;

  const onClickStatusFilter = (id) => {
    if (isDisabled) return;

    dispatch(
      setOrderFilter({
        ...filter,
        subCustomStatus: activeSubStatus === id ? null : id,
        currentPage: 1,
      })
    );
  };

  // Config mapping for all custom statuses
  const statusConfig = {
    1: [
      { id: 1, label: "Tracking Details not added", key: "status_unfulfilled_tracking_details_not_added" },
      { id: 2, label: "Invoice not added", key: "status_unfulfilled_invoices_not_added" },
      { id: 3, label: "Having Errors", key: "status_unfulfilled_having_errors" },
      { id: 4, label: "Unallocated Seller", key: "status_unfulfilled_unallocated_seller" },
      { id: 5, label: "Unallocated Shipping Orders", key: "status_unfulfilled_unallocated_delivery_partner" },
      { id: 6, label: "Test Order", key: "status_unfulfilled_test_order" },
      { id: 7, label: "Fraudulent order", key: "status_unfulfilled_fraudulent_order" },
      { id: 8, label: "Cancelled order", key: "status_unfulfilled_canceled_order" },
    ],
    2: [
      { id: 9, label: "Having Errors", key: "status_tracking_details_added_having_errors" },
      { id: 10, label: "Test Order", key: "status_tracking_details_added_test_order" },
      { id: 11, label: "Fraudulent order", key: "status_tracking_details_added_fraudulent_order" },
      { id: 12, label: "Cancelled order", key: "status_tracking_details_added_cancelled_order" },
    ],
    5: [
      { id: 13, label: "Order Dispatched", key: "status_stuck_in_transit_order_dispatched_no_events" },
      { id: 14, label: "Stuck at Customs", key: "status_stuck_in_transit_at_customs" },
      { id: 15, label: "Stuck in Transit", key: "status_stuck_in_transit_not_in_custom" },
    ],
  };

  if (!customStatus || !statusConfig[customStatus]) return null;

  const rows = [];
  const colsPerRow = 6;

  for (let i = 0; i < statusConfig[customStatus].length; i += colsPerRow) {
    const rowItems = statusConfig[customStatus].slice(i, i + colsPerRow);
    rows.push(
      <Row key={i} style={{ marginTop: 5, marginBottom: 10, paddingLeft: 10, paddingRight: 10 }}>
        {rowItems.map(({ id, label, key }) => (
          <Col md={2} className="col-container" key={id}>
            <div className={activeSubStatus === id ? "sub-filter-container-n" : "sub-filter-container"} onClick={() => onClickStatusFilter(id)}>
              <p className={activeSubStatus === id ? "button-text-n" : "button-text"}>{label}</p>
              <p className={activeSubStatus === id ? "income-value-n" : "income-value"}>{statusSummary?.[key] || 0}</p>
            </div>
          </Col>
        ))}
      </Row>
    );
  }

  return <>{rows}</>;
};

export default SubFilters;
